import { Component } from '@angular/core';

@Component({
  selector: 'app-insights-layout',
  template: '<router-outlet></router-outlet>'
})
export class InsightsLayout {
}

